import './NewsletterForm.css';
import React from 'react';

const NewsletterForm = () => {
    return (
        <h2>Newsletter Signup Coming Soon!</h2>
        // <form className="w-full max-w-sm mx-auto p-4 bg-white/10 backdrop-blur-sm rounded-2xl shadow-md flex flex-col gap-4">
        //     <h2 className="text-xl font-bold tracking-wide text-gray-100">
        //         Join My Newsletter
        //     </h2>
        //     <p>
        //         Get updates on new releases and upcoming events directly to your inbox, plus an exclusive
        //         story only available to newsletter subscribers!
        //     </p>
        //     <div className='form-field'>
        //         <label className="flex flex-col gap-2">
        //             <span className="text-gray-200 text-sm">Your Name</span>
        //             <input
        //                 type="text"
        //                 required
        //                 placeholder="e.g., Jane Doe"
        //                 className="p-2 rounded-lg bg-white/20 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-400"
        //             />
        //         </label>
        //     </div>
        //     <div className='form-field'>
        //         <label className="flex flex-col gap-2">
        //             <span className="text-gray-200 text-sm">Email Address</span>
        //             <input
        //             type="email"
        //             required
        //             placeholder="you@example.com"
        //             className="p-2 rounded-lg bg-white/20 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-400"
        //             />
        //         </label>
        //     </div>
        //     <button
        //         type="submit"
        //         className="mt-2 py-2 rounded-lg bg-purple-600 hover:bg-purple-700 text-white font-semibold transition-all"
        //     >
        //         Subscribe
        //     </button>
        // </form>
    )
}

export default NewsletterForm;